import { IPage } from '@types'
import DeliveryView from 'components/delivery/DeliveryView'
import Layout from 'components/layouts/Layout'
import { generateStaticProps } from 'lib/generateStaticProps'
import { getAbout } from 'lib/getAbout'
import { assocPath } from 'lib/utils'
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next'

export let getStaticProps = async (ctx: GetStaticPropsContext) => {
  let staticProps = await generateStaticProps(ctx, 'delivery')

  let about = await getAbout('ru')
  let thanks = about.filter((i) => i.type === 'thanks')

  let result = {
    ...staticProps,
    props: { ...staticProps.props, thanks },
  }

  return assocPath(
    'props.contentSplitted',
    result.props.content?.split('<!--divider-->'),
    result
  )
}

export type DeliveryPageProps = InferGetStaticPropsType<
  typeof getStaticProps
> & { contentSplitted: string[] }

let DeliveryPage: IPage<DeliveryPageProps> = ({
  thanks,
  contentSplitted,
  name,
}) => <DeliveryView thanksSSR={thanks} content={contentSplitted} name={name} />

DeliveryPage.getLayout = (page) => (
  <Layout
    index
    title={page.props?.title || ' Доставка'}
    description={page.props?.description}
    keywords={page.props?.keywords}
    menus={page.props.menus}
  >
    {page}
  </Layout>
)

export default DeliveryPage
